import { Pagination } from 'react-bootstrap';

function PaginationBar({ currentPage, totalPages, pageSize, totalItems, onPageChange }) {
  if (totalItems === 0) return null;

  const start = (currentPage - 1) * pageSize + 1;
  const end   = Math.min(currentPage * pageSize, totalItems);

  // Build page list with ellipsis gaps
  const delta = 2;
  const raw = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
      raw.push(i);
    }
  }
  const items = [];
  let prev = 0;
  for (const i of raw) {
    if (i - prev > 1) items.push('gap-' + i);
    items.push(i);
    prev = i;
  }

  return (
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      <small className="text-muted">
        Showing {start}–{end} of {totalItems} user{totalItems !== 1 ? 's' : ''}
      </small>
      {totalPages > 1 && (
        <Pagination className="mb-0">
          <Pagination.Prev disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)} />
          {items.map(item =>
            typeof item === 'string' ? (
              <Pagination.Ellipsis key={item} disabled />
            ) : (
              <Pagination.Item key={item} active={item === currentPage} onClick={() => onPageChange(item)}>
                {item}
              </Pagination.Item>
            )
          )}
          <Pagination.Next disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)} />
        </Pagination>
      )}
    </div>
  );
}

export default PaginationBar;
